<template>
  <div class="stafflist">
    <!-- 车牌列表 开始 -->
    <div class="licese_list" v-if="staffList.length>0">
    <!-- @click="toStaffEdit(index)" 编辑 -->
      <div class="licese_box" v-for="(item,index) in staffList" >
        <div class="licese_box_left">
          <img class="licese_redio" src="/static/textimg.jpg" />
          <div class="licese_mesg">
            <div class="textfont marginbottom" style="font-weight: bold;">备注：{{item.name}}</div>
            <div class="textfont marginbottom">手机：{{item.mobile}}</div>
            <div class="textfont tipcolor">密码：{{item.password}}</div>
          </div>
        </div>
        <img class="licese_shanchu" @click.stop="delStaff(index)" src="../../../static/del.png" />
      </div>

    </div>
    <div v-else class="nonebox">
      <img class="staffnone" src="/static/nothing.png" />
    </div>
    <!-- 车牌列表 结束 -->
    <!-- 新增车牌 开始 -->
    <div class="addbotton1" @click="toaddStaff">新增店员</div>
    <!-- 新增车牌 结束 -->
  </div>
</template>

<script>
  // import swal from 'sweetalert'
  import httper from '../../../api/http.js'
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        staffList: [], // 接口获取店员列表,默认为空
        licenseIndex: 0, // 车信息指针,默认为0
        buttonClicked: false, // 防止用户重复点击,默认为false
        isSelectLicense: false,
      }
    },
    created() {
      this.request("")
    },
    mounted() {
      this.request('storeStaffList')
    },
    methods: {
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      //添加店员
      toaddStaff() {
        this.$router.push({
          name: 'addStaff',
          params: {
            edit: 0
          }
        })
      },
      // 跳转到编辑店员信息页
      toStaffEdit(index) {
        let staffmesg = this.staffList[index]
        this.$router.push({
          name: 'addStaff',
          params: {
            staffMesg: JSON.stringify(staffmesg),
            edit: 1
          }
        })
      },

      //删除店员信息
      delStaff(e) {
        let that = this
        Dialog.confirm({
            title: '提示',
            message: '确认删除?',
          })
          .then(() => {
            let requestData = {
              admin_id: that.staffList[e].id
            }
            this.request('delStaff', requestData)
            // this.request("storeStaffList")
          })
      },

      request(type = '', requestData = {}) {
        let that = this
        let data = {}
        switch (type) {
          // 获取店员列表
          case 'storeStaffList':
            httper.post('store/my-admin', requestData, res => {
              if (res.code == 0) {
                that.staffList = res.data
              } else {
                that.$toast({
                  message: res.message || '操作失败',
                });
              }
            })
            break
            // 删除店员
          case 'delStaff':
            httper.get('store/del-admin', requestData, res => {
              if (res.code === 0) {
                window.location.reload() //页面刷新
              } else {
                that.$toast({
                  message: '删除失败',
                })
              }
            }, true)
            break
        }
      }
    }
  }
</script>

<style scoped>
  .licese_list {
    width: calc(100% - 20px);
    margin: 10px;
  }

  .licese_box {
    width: 100%;
    background: #FFFFFF;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
  }

  .licese_box_left {
    display: flex;
    align-items: center;
  }

  .licese_redio {
    margin-right: 10px;
    width: 60px;
    height: 60px;
    border-radius: 30px;
  }

  .licese_mesg {
    display: flex;
    flex-direction: column;
  }


  .licese_shanchu {
    width: 30px;
    height: 30px;
  }

  .liceselist_button {
    position: fixed;
    bottom: 50px;
  }

  .lice_none {
    left: 40%;
  }

  .nonebox {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    position: absolute;
    top: 100px;
  }

  .staffnone {
    width: 200px;
    height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/store/staffList.vue